import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {
    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    employeeChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.employeeChannel.next({ status: apiResponse.INITIAL })
        this.rowtableChannel.next({ status: apiResponse.INITIAL })
        this.inactiveChannel.next({ status: apiResponse.INITIAL })
    }

    fetchEmployee = async (query, cancelToken) => {
        this.employeeChannel.next({  status: apiResponse.LOADING })
        try {
            await this.repository.fetchEmployeeDetail(query, cancelToken).then((result) => {
                this.employeeChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.employeeChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchRowTable = async (query, cancelToken) => {
        this.rowtableChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

}

export default IndexBloc